<!-- Return Request Print Popup -->
<div class="popup-overlay" [class.show]="visible" (click)="close()">
  <div class="popup-content" (click)="$event.stopPropagation()">

    <div class="popup-header">
      <h4 class="popup-title">
        <span class="popup-title-icon">
          <i class="fas fa-print"></i>
        </span>
        Stampa Reso
        <span *ngIf="request?.palletCode" class="popup-title-code">{{ request?.palletCode }}</span>
      </h4>
      <button type="button" class="btn-close" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">

      <!-- ===== Pallet in visione (stessa presentazione del riepilogo) ===== -->
      <h5 class="summary-subtitle">
        <i class="fas fa-pallet me-2"></i>
        Pallet ({{ pallets.length }})
      </h5>

      <div class="summary-list mb-4">
        <div class="summary-row" *ngFor="let pallet of pallets; let i = index; trackBy: trackByPalletCode"
             [class.summary-row--selected]="isSelectedPallet(pallet)">
          <span class="summary-index">{{ i + 1 }}</span>
          <div class="summary-main">
            <span class="summary-code">{{ pallet.palletCode || '-' }}</span>
            <span class="summary-meta" *ngIf="pallet.palletDeliveryType">{{ pallet.palletDeliveryType }}</span>
          </div>
          <div class="summary-values">
            <span *ngIf="pallet.palletWeight != null">{{ pallet.palletWeight | number:'1.0-3' }} kg</span>
            <span *ngIf="pallet.palletVolume != null">{{ pallet.palletVolume | number:'1.0-4' }} m³</span>
            <span class="summary-waybill" *ngIf="pallet.palletWaybillCode">
              <i class="fas fa-file-alt me-1"></i>{{ pallet.palletWaybillCode }}
            </span>
          </div>
        </div>

        <div class="summary-empty" *ngIf="!pallets.length">
          <i class="fas fa-inbox me-2"></i>Nessun pallet da mostrare
        </div>
      </div>

      <!-- ===== Bolla in visione ===== -->
      <h5 class="summary-subtitle">
        <i class="fas fa-file-alt me-2"></i>
        {{ waybills.length === 1 ? 'Bolla' : 'Bolle' }} ({{ waybills.length }})
      </h5>

      <div class="summary-list mb-4">
        <div class="summary-row" *ngFor="let waybill of waybills; let i = index; trackBy: trackByWaybillCode">
          <span class="summary-index">{{ i + 1 }}</span>
          <div class="summary-main">
            <span class="summary-code">{{ waybill.waybillCode }}</span>
            <span class="summary-meta">{{ waybill.pallets.length }} pallet</span>
          </div>
          <div class="summary-values">
            <span class="summary-pallet-code" *ngFor="let pallet of waybill.pallets; trackBy: trackByPalletCode">
              {{ pallet.palletCode }}
            </span>
          </div>
        </div>

        <div class="summary-empty" *ngIf="!waybills.length">
          <i class="fas fa-inbox me-2"></i>Nessuna bolla associata
        </div>
      </div>

      <div class="row g-3">

        <!-- Card: Stampa Label -->
        <div class="col-md-6">
          <div class="print-card">
            <div class="print-card-icon print-card-icon--label">
              <i class="fas fa-tag"></i>
            </div>
            <h5 class="print-card-title">
              {{ pallets.length === 1 ? 'Stampa della Label' : 'Stampa delle Label' }}
            </h5>
            <p class="print-card-text">
              Stampa {{ pallets.length === 1 ? "l'etichetta da applicare sul contenitore del reso" :
                        'in un unico PDF le etichette dei ' + pallets.length + ' pallet elencati, una per pagina' }}.
            </p>
            <button type="button" class="btn btn-primary w-100" (click)="printLabel()"
                    [disabled]="isGeneratingLabel || !pallets.length">
              <i class="fas" [ngClass]="isGeneratingLabel ? 'fa-spinner fa-spin me-1' : 'fa-print me-1'"></i>
              {{ isGeneratingLabel ? 'Generazione...' : 'Stampa label' }}
            </button>
          </div>
        </div>

        <!-- Card: Stampa Bolla -->
        <div class="col-md-6">
          <div class="print-card">
            <div class="print-card-icon print-card-icon--waybill">
              <i class="fas fa-file-alt"></i>
            </div>
            <h5 class="print-card-title">
              {{ waybills.length === 1 ? 'Stampa della Bolla' : 'Stampa delle Bolle' }}
            </h5>
            <p class="print-card-text">
              Stampa {{ waybills.length === 1 ? 'la bolla di accompagnamento del reso' :
                        'in un unico PDF le ' + waybills.length + ' bolle elencate' }}.
            </p>
            <button type="button" class="btn btn-primary w-100" (click)="printWaybill()"
                    [disabled]="isGeneratingWaybills || !waybills.length">
              <i class="fas" [ngClass]="isGeneratingWaybills ? 'fa-spinner fa-spin me-1' : 'fa-print me-1'"></i>
              {{ isGeneratingWaybills ? 'Generazione...' : (waybills.length === 1 ? 'Stampa bolla' : 'Stampa bolle') }}
            </button>
          </div>
        </div>

      </div>
    </div>

    <div class="popup-footer d-flex justify-content-end">
      <button type="button" class="btn btn-outline-secondary" (click)="close()">
        <i class="fas fa-times me-1"></i> Chiudi
      </button>
    </div>

  </div>
</div>
